// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--G5Rvu","item":"_7a3fb80146--item--BEtnV","faq":"_7a3fb80146--faq--tzECO","value-wrapper":"_7a3fb80146--value-wrapper--twcmt"};